import { FC } from 'react';
import styles from './faq-item.module.scss';
import classNames from 'classnames';

export interface FAQItemProps {
    question?: string;
    answer?: string;
    isOpen?: boolean;
    zIndex?: number;
    onQuestionClick?: (question: string) => void;
}

const FAQItem: FC<FAQItemProps> = (props) => {
    const { question, answer, isOpen, zIndex, onQuestionClick } = props;

    const handleFQA = () => {
        if (onQuestionClick) {
            onQuestionClick(question || '');
        }
    };

    return (
        <div className={classNames(styles.container, { [styles.containerExpanded]: isOpen })} style={{ zIndex }} onClick={handleFQA}>
            <div className={`${styles.divider} ${isOpen ? styles.hidden : ''}`}></div>
            <div className={styles.wrapperQuestion}>
                <div className={styles.question} dangerouslySetInnerHTML={{ __html: question || '' }}></div>

                <div className={`${styles.icon} ${isOpen ? styles.opened : styles.closed}`} onClick={handleFQA}>
                    <div className={styles.horizontal}></div>
                    <div className={styles.vertical}></div>
                </div>
            </div>

            <div className={`${styles.wrapperAnswer} ${isOpen ? styles.showAnswer : ''}`}>
                <div className={styles.answer} dangerouslySetInnerHTML={{ __html: answer || '' }}></div>
            </div>
        </div>
    );
};

export default FAQItem;
